import { renderWeekly } from "./scripts/components/Weekly";
import { renderMonthly } from "./scripts/components/Monthly";
import { renderTwoMonth } from "./scripts/components/TwoMonth";
import { removeLabels } from "./scripts/helpers/Labels";

window.addEventListener("DOMContentLoaded", (e) => {
	$ = jQuery.noConflict();

	const calendars = document.querySelectorAll('.rpm-calendar .calendar');

	if( calendars && calendars.length > 0 ) {
		let performances = limelight.performances;
		if( performances && performances.length ) {
			try {
				calendars.forEach(calendar => {
					switch (calendar.dataset.type) {
						case 'weekly':
							renderWeekly(calendar);
							break;
						case 'twomonth':
							renderTwoMonth(calendar);
							break;
						default:
							renderMonthly(calendar);
							break;
					}
					removeLabels();
				});
			} catch (error) {
				console.error(error);
			}
		} else {
			// console.log('No performances present.');
		}
	} else {
		// console.log('No calendars present.');
	}

});
